import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PeopleSdk } from 'lib-klab-sdks';
import { ChatDirectoryPort } from '../../../app/ports/people/chat-directory.port';

@Injectable({ providedIn: 'root' })
export class ChatDirectoryPortAdapter implements ChatDirectoryPort {
  constructor(private readonly chatContactsApi: PeopleSdk.ChatContactsService) {}

  getContacts(page: number, size: number, q?: string): Observable<PeopleSdk.PagedChatContactResponse> {
    return this.chatContactsApi.getChatContactsByQuery(page, size, q);
  }
}
